import React, { useState, useEffect } from 'react';
import './LoginPage.css'; // File untuk styling
import logo from '../../assets/GlobalLogo_NTTDATA_FutureBlue_RGB.png';
import CryptoJS from 'crypto-js';
import { useNavigate } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button,
    TextField,
    InputAdornment, 
    IconButton,
} from "@mui/material";

function LoginPage() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [ipAddress, setIpAddress] = useState('');
    const [error, setError] = useState('');
    const [token, setToken] = useState('');
    // const [successToken, setSuccessToken] = useState('');
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const resource = "login";
    const storedToken = localStorage.getItem("token");
    const [otpInput, setOtpInput] = useState('');
    const [showOtpModal, setShowOtpModal] = useState(false);
    const [showUpdateExpiredPasswordsModal, setShowUpdateExpiredPasswordsModal] = useState(false);
    const [showUpdatePasswordsSuccessModal, setShowUpdatePasswordsSuccessModal] = useState(false);  
    const [isLoginProcess, setIsLoginProcess] = useState(false);
    const [resendOtpMessage, setResendOtpMessage] = useState('');
    const [loginResponseMessage, setLoginResponseMessage] = useState('');
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);
    const [open, setOpen] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [forgetEmail, setForgetEmail] = useState("");
    const [errorForgetEmail, setErrorForgetEmail] = useState("");
    const [isSubmittingForgetPassword, setIsSubmittingForgetPassword] = useState(false);

    useEffect(() => {
        async function getIPAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();

                const ipAddress = data.ip;
                setIpAddress(ipAddress);
                
            } catch (error) {
                console.error('Error fetching IP address:', error);
            }
        }

        getIPAddress();

        const checkSessionToken = async () => {
            try {
                const response = await fetch(
                    `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            authorization: "Basic eGNwOk50dGkyMDI0IQ==",
                        },
                    }
                );
                if (!response.ok) {
                    setError("Failed to fetch session token data");
                    throw new Error("Failed to fetch session token data");
                }

                const text = await response.text();
                const data = text === "true";
                
                if (data && !isLoginProcess) {                   
                    const isOperationUser = await fetchInternalData(storedToken)
                    if(isOperationUser){
                        navigate('/operation/order-list');
                    } else {
                        navigate('/order-list');
                    } 
                    // navigate("/order-list");
                }
            } catch (error) {
                console.error("Fetch Error:", error.message);
                setError("Fetch Error: " + error.message);
            }
        };

        checkSessionToken();
    }, [storedToken, resource, navigate]);

    function sha256(input) {
        return CryptoJS.SHA256(input).toString(CryptoJS.enc.Hex);
    }

    function md5(input) {
        return CryptoJS.MD5(input).toString(CryptoJS.enc.Hex);
    }

    function getLocalDate() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Bulan dimulai dari 0
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }

    function generateOtp() {
        return String(Math.floor(100000 + Math.random() * 900000)); // 6-digit OTP
    }

    // CODE FOR PASSWORD EXPIRATION
    const handleClickShowOldPassword = () => setShowOldPassword((prev) => !prev);
    const handleClickShowNewPassword = () => setShowNewPassword((prev) => !prev);
    const handleClickShowConfirmNewPassword = () => setShowConfirmNewPassword((prev) => !prev);
    const localDateNow = getLocalDate();

    async function login(isResendCode = false){
        let hashedPassword = md5(password);
        hashedPassword = sha256(hashedPassword);
        try {
            const otp = generateOtp();
            const response = await fetch('https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    authorization: "Basic eGNwOk50dGkyMDI0IQ==",
                },
                body: JSON.stringify({
                    email: email,
                    password: hashedPassword,
                    otp: otp,
                    ip: ipAddress,
                    localDate: localDateNow,
                    isResendCode: isResendCode
                }),
            });

            const data = await response.json();
            const responseBody = JSON.parse(data.body);
            const statusCode = data.statusCode;

            let isPasswordExpired = false

            if (responseBody.messageCode == 'expired-passwords') {
                isPasswordExpired = true
                setShowUpdateExpiredPasswordsModal(true)
            }

            if (!response.ok) {
                setError(responseBody.message || 'Network response was not ok.');
                throw new Error('Network response was not ok.');
            }

            if (statusCode !== 200) {
                setError(responseBody.message || 'Network response was not ok.');
            } else {
                setError("");
                setLoginResponseMessage(responseBody.message)
                if(!isPasswordExpired){
                    setShowOtpModal(true); 
                }             
                // if mfa inactive     
                if(responseBody.token != null){
                    setError("");
                    setShowOtpModal(false);            
                    const { token } = responseBody;
                    setToken(token);
                    localStorage.setItem('token', token);
                    const isOperationUser = await fetchInternalData(token)

                    if(isOperationUser){
                        navigate('/operation/order-list');
                    } else {
                        navigate('/order-list');
                    }                 
                }
                setIsLoginProcess(true);
            }
        } catch (error) {
            console.error('Fetch Error:', error.message);
        } finally {
            setIsSubmitting(false);
        }
    }

    const handleSubmit = async (event) => {
        
        event.preventDefault();

        if (!email && !password) {
            setError('Please enter both email and password.');
            return;
        }

        if (!email) {
            setError('Please enter email.');
            return;
        }

        if (!password) {
            setError('Please enter password.');
            return;
        }

        setIsSubmitting(true);

        

        login()
    };

    const fetchInternalData = async (generateOtpToken) => {
            try {
              const response = await fetch(
                `https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/find-by-token?token=${generateOtpToken}`,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    authorization: "Basic eGNwOk50dGkyMDI0IQ==",
                  },
                }
              );
      
              const data = await response.json();
      
              if (!response.ok) {
                setError(data.message || "Failed to fetch internal data");
                throw new Error(data.message || "Failed to fetch internal data");
              }
              if(data[0].xcp_role_code === "XCPRLE-005" ){
                return true
              } else {
                return false
              }
            return
            } catch (error) {
              console.error("Fetch Error:", error.message);
              setError("Fetch Error: " + error.message);
            }
          };

    const handleOtpSubmit = async () => {
        if (otpInput.length < 6 || otpInput.length > 6) {
            setError('Please enter a valid 6-digit code.');
            return;
        }

        try {
            const response = await fetch('https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/mfa-authentication', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    authorization: "Basic eGNwOk50dGkyMDI0IQ==",
                },
                body: JSON.stringify({
                    email: email,
                    otp: otpInput,
                    ip: ipAddress,
                    localDate: localDateNow
                }),
            });
            const data = await response.json();
            const responseBody = JSON.parse(data.body);

            if (!response.ok) {
                setError(responseBody.message || 'Network response was not ok.');
                throw new Error('Network response was not ok.');
            }
        
            if(responseBody.token != null){
                    setError("");
                    setShowOtpModal(false);                 
                    const { token } = responseBody;
                    setToken(token);
                    localStorage.setItem('token', token);
                    const isOperationUser = await fetchInternalData(token)

                    if(isOperationUser){
                        navigate('admin/order-list');
                    } else {
                        navigate('/order-list');
                    }                 
                    
            } else {
                if (responseBody.messageCode == 'invalid-otp') {
                    setError(responseBody.message);               
                } else if(responseBody.messageCode == 'block-account'){
                    setError(responseBody.message);
                    setShowOtpModal(false);
                } else if(responseBody.messageCode == 'expired-otp'){
                    setError(responseBody.message);
                    setShowOtpModal(false);
                }   
            }
    } catch (error) {
            console.error('Fetch Error:', error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleUpdateExpiredPasswordsSubmit = async () => {
        function sha256(input) {
            return CryptoJS.SHA256(input).toString(CryptoJS.enc.Hex);
        }
    
        function md5(input) {
            return CryptoJS.MD5(input).toString(CryptoJS.enc.Hex);
        }
        let hashedOldPassword = md5(oldPassword);
        hashedOldPassword = sha256(hashedOldPassword);

        const formData = {
            oldPassword: hashedOldPassword,
            newPassword: newPassword,
            confirmNewPassword: confirmNewPassword,
            email: email,
          };

        try {
            const response = await fetch('https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/update-expired-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    authorization: "Basic eGNwOk50dGkyMDI0IQ==",
                },
                body: JSON.stringify(formData),
            });
            const data = await response.json();
            const responseBody = JSON.parse(data.body);

            if (!response.ok) {
                setError(responseBody.message || 'Network response was not ok.');
                throw new Error('Network response was not ok.');
            }

            const { message } = responseBody;
            const statusCode = data.statusCode;
            if (message == "success") {
                setShowUpdateExpiredPasswordsModal(false)
                setShowUpdatePasswordsSuccessModal(true)                
            } else if (statusCode != 200){
                setError(responseBody.message || 'Network response was not ok.');
            } 
    } catch (error) {
            console.error('Fetch Error:', error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    const resendCode = async () => {
        setResendOtpMessage('Successfully resend OTP code')
        login(true)
    }

    function handleBackToLogin(){
        setShowUpdatePasswordsSuccessModal(false)  
    }

    //new code colaboration
    const handleClose = () => {
        setOpen(false);
        navigate("/login");
      };
    
      const handleConfirmation = async (event) => {
        setErrorForgetEmail("");
    
        if (!forgetEmail) {
          setErrorForgetEmail("Please enter email.");
          return;
        }
    
        setIsSubmittingForgetPassword(true);
    
        const formData = {
          email: forgetEmail,
        };
    
        try {
          const response = await fetch(
            "https://4sx2gdf0k6.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/forget-password",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                authorization: "Basic eGNwOk50dGkyMDI0IQ==",
              },
              body: JSON.stringify({ email: forgetEmail }),
            }
          );
    
          const data = await response.json();
          const responseBody = JSON.parse(data.body);
          const statusCode = data.statusCode;
    
          if (!response.ok) {
            setErrorForgetEmail(
              responseBody.message || "Network response was not ok."
            );
            throw new Error("Network response was not ok.");
          }
    
          if (statusCode != 200) {
            setErrorForgetEmail(
              responseBody.message || "Network response was not ok."
            );
          } else {
            setErrorForgetEmail("");
    
            setOpen(false);
            setOpenConfirmation(true);
          }
        } catch (error) {
          console.error("Fetch Error:", error.message);
        } finally {
          setIsSubmittingForgetPassword(false);
        }
      };
    
      const handleFinish = () => {
        setOpenConfirmation(false);
      };

    return (
        <div className="center-login">
            <div className="login-box">
                <img src={logo} alt="Logo" />
                <div className="title-box-login">
                    <p>NTT Indonesia Cross Connect Portal</p>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="textbox-login">
                        <input
                            type="text"
                            placeholder="Enter your Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    <div className="textbox-login">
                        <input
                            type="password"
                            placeholder="Enter your Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    {error && <p className="error-message">{error}</p>}
                    <input
                        type="submit"
                        className="btn-login"
                        value="Login"
                        disabled={isSubmitting}
                    />
                    <input type="hidden" name="token" value={token} /> {/* Hidden token field */}
                    <div className="forgot-password-login">
                        <a
                        href="#"
                        className="forgot-password-link-login"
                        onClick={(e) => {
                            e.preventDefault(); // Mencegah aksi default href
                            setOpen(true); // Menampilkan dialog
                        }}
                        >
                        Forget Password?
                        </a>
                    </div>
                </form>
            </div>

            <div>
                <Dialog open={open} onClose={handleClose}>
                <DialogTitle
                    style={{ textAlign: "left", fontWeight: "bold", fontSize: "24px" }}
                >
                    {"Cross Connect Forget Password"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                    <div className="centered-div">
                        <input
                        type="email"
                        placeholder="xxx@xxx.com"
                        className="email-input"
                        value={forgetEmail}
                        onChange={(e) => setForgetEmail(e.target.value)}
                        />
                        {errorForgetEmail && (
                        <p className="error-message">{errorForgetEmail}</p>
                        )}
                        <p className="instruction-text">
                        Fill your username and we will send you the reset link that
                        you can click on your email.
                        </p>
                    </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                    Cancel
                    </Button>
                    <Button
                    onClick={handleConfirmation}
                    color="primary"
                    autoFocus
                    disabled={isSubmittingForgetPassword}
                    >
                    Submit
                    </Button>
                </DialogActions>
                </Dialog>

                <Dialog open={openConfirmation}>
                <DialogTitle>
                    {"Link Reset has been sent successfully to your email,"}
                    <br />
                    {
                    "Please open the email and then click the link to reset your password."
                    }
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleFinish} color="primary" autoFocus>
                    OK
                    </Button>
                </DialogActions>
                </Dialog>
            </div>

            {/* OTP Dialog Inactive MFA */}
            <Dialog open={showOtpModal} onClose={() => setShowOtpModal(false)}>
                <DialogTitle>Enter OTP</DialogTitle>
                <DialogContent>
                    <DialogContentText>                       
                        {loginResponseMessage}
                    </DialogContentText>
                    <br />
                    <TextField
                        label="OTP"
                        variant="outlined"
                        fullWidth
                        value={otpInput}
                        onChange={(e) => setOtpInput(e.target.value)}
                    />
                    {error && <p style={{ color: 'red' }}>{error}</p>}
                    <p>{resendOtpMessage}</p>
                    <DialogContentText>
                        <p style={{ fontStyle: 'italic', display: 'inline' }}>Didn't receive the code?</p> 
                        <Button onClick={resendCode} color="primary">
                            Resend code
                        </Button>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowOtpModal(false)} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleOtpSubmit} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            {/* //Expire password */}
            <Dialog open={showUpdateExpiredPasswordsModal} onClose={() => setShowUpdateExpiredPasswordsModal(false)}
                 sx={{
                    '& .MuiDialog-paper': {
                      width: '41%',  // Mengatur lebar dialog menjadi 80% dari lebar layar
                      maxWidth: 'none', // Menghapus batasan maxWidth
                    }
                  }}>
                <DialogTitle>Cross Connect Update Expired Passwords</DialogTitle>
                <DialogContent>
                    <DialogContentText>                       
                        Your password has expired, please update your password by filling out the following form:
                    </DialogContentText>
                    <br />
                    <TextField
                        label="Old Password"
                        variant="outlined"
                        fullWidth
                        type={showOldPassword ? 'text' : 'password'}  // Menampilkan password jika showOldPassword true
                        value={oldPassword}
                        onChange={(e) => setOldPassword(e.target.value)}
                        sx={{ marginBottom: 2 }} 
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={handleClickShowOldPassword} edge="end">
                                  {showOldPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                    />
                    <TextField
                        label="New Password"
                        variant="outlined"
                        fullWidth
                        type={showNewPassword ? 'text' : 'password'}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        sx={{ marginBottom: 2 }} 
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={handleClickShowNewPassword} edge="end">
                                  {showNewPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                    />
                    <TextField
                        label="Confirm New Password"
                        variant="outlined"
                        fullWidth
                        type={showConfirmNewPassword ? 'text' : 'password'} 
                        value={confirmNewPassword}
                        onChange={(e) => setConfirmNewPassword(e.target.value)}
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={handleClickShowConfirmNewPassword} edge="end">
                                  {showConfirmNewPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                    />
                    
                    <p>{resendOtpMessage}</p>
                    <DialogContentText>
                        <p style={{ margin: 0, fontStyle: 'italic' }}>Password requirements:</p>
                        <p style={{ margin: 0, fontStyle: 'italic' }}>1. Password length between 6 to 20 characters</p>
                        <p style={{ margin: 0, fontStyle: 'italic' }}>2. Password contains combination between upper case and lower case character</p>
                        <p style={{ margin: 0, fontStyle: 'italic' }}>3. Password contains at least 1 number</p>
                        <p style={{ margin: 0, fontStyle: 'italic' }}>4. Password contains at least 1 special character</p>
                    </DialogContentText>
                </DialogContent>
                {error && <p style={{ color: 'red', marginLeft: '20px' }}>{error}</p>}
                <DialogActions>
                    <Button onClick={handleUpdateExpiredPasswordsSubmit} color="primary">
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={showUpdatePasswordsSuccessModal} onClose={() => setShowUpdatePasswordsSuccessModal(false)}>
                <DialogTitle>{"Your password has been updated successfully."}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        To continue, please click the button below to log in.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleBackToLogin} color="primary" autoFocus>
                    Back to login
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default LoginPage;
